angular.module('iqxCore')
.service('sendMessageDialogSvc', function (ApplicationSvc, ApiSvc, $q) {
  var svc=this
  
  svc.createMessageFromDialog=function(scope,ptype,ptitle,plinks) {  // Opens a dialog which posts an IQX message
    var data={ptype:ptype,ptitle:ptitle}
    return ApplicationSvc.openDialog({
      templateUrl: 'views/message.html',
      size: 'md',
      backdrop: 'static',
      controller:'SendMessageDialogCtrl',
      scope:scope,   // Specify the parent scope of the dialog's scope
      resolve: {
        getData: function() {
          return {theRecord:data,theLinks:plinks}
          }
        }
      })
    }

  svc.saveMessage=function(scope,ptype,ptitle,pdescription,plinks) {  // Programmatically posts an IQX message
    // scope.formError will be set if there is an error
    if (!ptype) {return $q.reject(scope.formError='Message type required')}
    if (!ptitle) {return $q.reject(scope.formError='Message title required')}
    plinks=plinks || {}  // Links are optional - can include pvacancyid, pplacementid, pprogressid, pprovtimesheetid, ptimesheetid 
    plinks.ptype=ptype
    plinks.ptitle=ptitle
    plinks.pdescription=pdescription || ''
    return ApiSvc.exec(scope,'call/NetMessage',plinks)
    }
})
